export default import.meta.ROLLDOWN_FILE_URL_TSxOfKSnEFu5SrHkQZDEEA